import { useQuery } from '@tanstack/react-query'
import { getPickingPath, isProviderAPos } from '../../../../services/Provider/Provider.service'
import { TIME } from '../../../../services/date.service'
import useUser from '../../../Shared/UserProvider/useUser'

const usePickingPath = () => {
    const { user } = useUser()

    const {data: pickingPath, isLoading: isPickingPathLoading} = useQuery({
        queryFn: () => getPickingPath(user.provider.id),
        queryKey: ['providers', user?.provider?.id, 'picking-path'],
        enabled: isProviderAPos(user.provider),
        staleTime: 4 * TIME.HOUR_IN_MS
    })

    return {
        pickingPath,
        isPickingPathLoading,
    }
}

const getAislesNotInPickingPath = (aisles, pickingPath) => {
    const pickingPathAisleIds = new Set(pickingPath.map(aisle => aisle.id) || [])

    return aisles.filter(aisle => !pickingPathAisleIds.has(aisle.id))
        .sort((a, b) => a.name.localeCompare(b.name))
      || []
}

export { usePickingPath, getAislesNotInPickingPath }
